import { combineReducers } from "redux";
import authReducer from "./authReducer";
import settingsReducer from "./settingsReducer";

// Combinar los reducer de la aplicación
export default combineReducers({
    authReducer,
    settingsReducer
});
